import { useEffect } from 'react';

import Lottie from 'react-lottie-player';
import LogoFilled from '../../assets/images/Logo-Filled.png';
import { Stack, Typography } from '@mui/material';
import { Title, DetailText } from './styled_components/match.style';

export default function LoadingScreen({
  rotatingText,
  loadingAnimation,
}) {
  return (
    <Stack spacing={2} sx={{ alignItems: 'center' }}>
      <Typography variant="h6">Finding your recommendations...</Typography>
      <DetailText>{rotatingText}</DetailText>
      <Lottie
        loop
        animationData={loadingAnimation}
        play
        style={{ width: 200, height: 200 }}
      />
    </Stack>
  );
}
